<template>
  <div class="order-boat">
    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="154.34" height="116.28" viewBox="0 0 154.34 116.28"><path d="M26.73 48.13l.08-18.38s-3.74-3-7.3 1.31c-1.7 1.8-3.61 8.22-3.61 8.22l-.36 28z" fill="#ea5959"/><path d="M56.42 46.13l-39.13-2.79-5.51 6.35 5.75 2.1s-5.36 5.34-8.86 18.71l1.5 32L37 87z" fill="#fff"/><path fill="#6d2e15" d="M52.6 54.43l-28.09-2.004.344-4.817 28.088 2.003z"/><path fill="#ff6e6e" d="M125.67 61h-67.5V0l73 5-5.5 56z"/><path fill="#ff8080" d="M58.17.19L30.43 44v42.44l28.49-22.92L58.17.19z"/><path fill="#fc9d9d" d="M30.54 69.06l28-31.5-.1 1.19L30.43 69.5l-.07-.5"/><path fill="#fc9d9d" d="M34.42 37.63l-.4.56v42.44l.49-4.01-.09-38.99zm3.82-5.92l-.4.56v43.69l.49-.38-.09-43.87zm5.5-8.79l-.41.56V71l.5-.54-.09-47.54zM50.57 12l-.4.56V55l.49-4.01L50.57 12z"/><path d="M62.76 32c-3.47 3.79-6.84 7.61-10.09 11.42l-5 23.58S8.59 102.62 8.93 102.06C3.19 110.85 0 116.28 0 116.28s71.33-17.91 120.81-1.45L154.34 7.29S99.78-8.45 62.76 32z" fill="#ea5959"/><path d="M128.23 91s-35.48-.82-66 4.54S0 116.28 0 116.28s63.16-1.65 120.81-1.45c-.72-.05 7.42-23.83 7.42-23.83z" fill="#6d2e15"/><ellipse cx="108.87" cy="27.76" rx="5.37" ry="4.12" transform="rotate(-70.84 108.873 27.758)" fill="none" stroke="#fc9d9d" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.108"/><ellipse cx="19.92" cy="66" rx="1.79" ry="1.37" transform="rotate(-70.54 19.915 66)" fill="#6d2e15"/><ellipse cx="15.52" cy="71.14" rx="1.79" ry="1.37" transform="rotate(-70.54 15.516 71.14)" fill="#6d2e15"/><ellipse cx="11.12" cy="76.29" rx="1.79" ry="1.37" transform="rotate(-70.54 11.117 76.281)" fill="#6d2e15"/><path fill="none" stroke="#fc9d9d" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.108" d="M143.34 3.33l-21 72.67"/><path fill="#fc9d9d" d="M30.54 53.38l28-31.5-.1 1.18-28.01 30.75-.07-.5"/></svg>
    <div class="extra-circle">
      <svg class="front-line" xmlns="http://www.w3.org/2000/svg" width="400.1" height="77.5" viewBox="0 0 400.1 77.5"><rect y="10" height="1" fill="#128282"/><path d="M400 10v1h.1v-1h-.1z" fill="#128282"/><path d="M400 10v1h.1v-1h-.1z" fill="#128282"/><path d="M400.1 11.5V10c-8-.06-12.14-2.42-16.31-4.93S375.24 0 366.77 0s-12.82 2.58-17 5.07-8.2 4.93-16.4 4.93-12.2-2.39-16.43-4.93S308.48 0 300 0s-12.77 2.58-16.93 5.07-8.2 4.93-16.4 4.93-12.18-2.39-16.41-4.93S241.81 0 233.34 0s-12.76 2.58-16.92 5.07S208.21 10 200 10s-12.17-2.39-16.4-4.93S175.15 0 166.68 0s-12.77 2.58-16.92 5.07S141.54 10 133.35 10s-12.19-2.39-16.41-4.93S108.48 0 100 0 87.24 2.58 83.09 5.07 74.87 10 66.68 10 54.49 7.61 50.26 5.07 41.81 0 33.34 0 20.62 2.58 16.46 5.07 8.1 10 .1 10v67.5h400v-66zM43.62 2.73z" fill="#128282"/><path fill="#27555b" d="M400 10h.1v1h-.1z"/></svg>
      <svg class="back-line" xmlns="http://www.w3.org/2000/svg" width="400.1" height="77.5" viewBox="0 0 400.1 77.5"><rect y="10" height="1" fill="#27555b"/><path d="M400 10v1h.1v-1h-.1z" fill="#27555b"/><path d="M400 10v1h.1v-1h-.1z" fill="#27555b"/><path d="M400.1 11.5V10c-8-.06-12.14-2.42-16.31-4.93S375.24 0 366.77 0s-12.82 2.58-17 5.07-8.2 4.93-16.4 4.93-12.2-2.39-16.43-4.93S308.48 0 300 0s-12.77 2.58-16.93 5.07-8.2 4.93-16.4 4.93-12.18-2.39-16.41-4.93S241.81 0 233.34 0s-12.76 2.58-16.92 5.07S208.21 10 200 10s-12.17-2.39-16.4-4.93S175.15 0 166.68 0s-12.77 2.58-16.92 5.07S141.54 10 133.35 10s-12.19-2.39-16.41-4.93S108.48 0 100 0 87.24 2.58 83.09 5.07 74.87 10 66.68 10 54.49 7.61 50.26 5.07 41.81 0 33.34 0 20.62 2.58 16.46 5.07 8.1 10 .1 10v67.5h400v-66zM43.62 2.73z" fill="#27555b"/><path fill="#27555b" d="M400 10h.1v1h-.1z"/></svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderBoat'
}
</script>

<style lang="scss" scoped>
.order-boat {
  position: relative;
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
}

.extra-circle {
  width: 195px;
  height: 195px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 5;
}

@keyframes waves {
  0% {
    transform: translateY(0) translateX(0);
  }

  100% {
    transform: translateY(0) translateX(66.67px);
  }
}

.back-line {
  position: absolute;
  bottom: -27px;
  left: -100px;
  z-index: 1;
  animation: waves 10s linear infinite;
}

.front-line {
  position: absolute;
  bottom: -48px;
  left: -150px;
  z-index: 2;
  animation: waves 6s linear infinite 1s;
}

@keyframes boat {
  0%,
  100% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-2deg);
  }

  75% {
    transform: rotate(1deg);
  }
}

.icon {
  position: absolute;
  top: 44px;
  left: 34px;
  z-index: 2;
  transform-origin: 50% 100%;
  animation: boat 6s linear infinite 1s;
}
</style>
